/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）、advertisingservice.html。
 * Section 7：cj-audience-cards 6 人群卡（PC 3 列 / iPad 2 列 / 移动 1 列）。
 * 注意事项：文案（kicker/title/desc/cards）经 ConstantsContext 取词，配色、序号与 SVG 图标为视觉资产保留在组件内。
 */
import React, { useContext } from 'react';
import ConstantsContext from './ConstantsContext';
import { mix } from '../colorMix';

// 视觉资产（配色 + 序号 + 图标）顺序与 AUDIENCE.cards 一一对应
var CARD_VISUALS = [
  { accent: '#4f7cff', soft: 'rgba(79,124,255,.12)', index: '01', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="8" r="3" /><path d="M5 20c0-4 3.1-7 7-7s7 3 7 7" /><path d="M18 5h3M19.5 3.5v3" /></svg>) },
  { accent: '#8b5cf6', soft: 'rgba(139,92,246,.12)', index: '02', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 7h16l-1 12H5L4 7Z" /><path d="M8 7a4 4 0 0 1 8 0" /><path d="M9 12h6" /></svg>) },
  { accent: '#31b7d8', soft: 'rgba(49,183,216,.12)', index: '03', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 20V9l8-5 8 5v11" /><path d="M8 20v-6h8v6" /><path d="M9 10h6" /></svg>) },
  { accent: '#2db788', soft: 'rgba(45,183,136,.12)', index: '04', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="8" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" /><path d="M3 20c0-4 2.2-7 5-7s5 3 5 7" /><path d="M13 15c1-.8 2.2-1.3 3.5-1.3 2.6 0 4.5 2.3 4.5 5.3" /></svg>) },
  { accent: '#e66aa2', soft: 'rgba(230,106,162,.12)', index: '05', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="7" y="2.5" width="10" height="19" rx="2.5" /><path d="M10 5h4M10 18h4" /><path d="m10 11 2 2 3-3" /></svg>) },
  { accent: '#ff914d', soft: 'rgba(255,145,77,.13)', index: '06', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.2 2.5 3.2 5.5 3.2 9S14.2 18.5 12 21M12 3C9.8 5.5 8.8 8.5 8.8 12S9.8 18.5 12 21" /></svg>) },
];

// 由 accent 主色预算派生 CSS 变量（等价原 less 的 color-mix）
function accentVars(accent, soft) {
  if (!accent) return { '--soft': soft };
  return {
    '--accent': accent,
    '--soft': soft,
    '--accent-hover-bd': mix(accent, '#dfe5ee', 30),      // hover 描边
    '--accent-icon-bd': mix(accent, 'transparent', 24),   // 图标描边
    '--accent-icon-bg': mix(accent, '#ffffff', 10),       // 图标浅底
    '--accent-icon-glow': mix(accent, 'transparent', 10), // 图标投影
    '--accent-idx-bd': mix(accent, '#edf1f6', 18),        // 序号描边
    '--accent-tx': mix(accent, '#273140', 78),            // 序号/label 文字（压暗）
    '--accent-idx-bg': mix(accent, '#ffffff', 7),         // 序号浅底
  };
}

function AudienceCards() {
  const { AUDIENCE } = useContext(ConstantsContext);
  return (
    <section className="cj-audience-cards">
      <div className="cj-audience-cards__wrap">
        <div className="cj-audience-cards__head">
          <div className="cj-audience-cards__kicker">{AUDIENCE.kicker}</div>
          <h2 className="cj-audience-cards__title">
            {AUDIENCE.title}
            <span className="accent"> {AUDIENCE.titleAccent}</span>
          </h2>
          <p className="cj-audience-cards__desc">{AUDIENCE.description}</p>
        </div>

        <div className="cj-audience-cards__grid">
          {AUDIENCE.cards.map((c, i) => {
            var v = CARD_VISUALS[i] || {};
            return (
              <article className="cj-audience-card" key={v.index} style={accentVars(v.accent, v.soft)}>
                <div className="cj-audience-card__top">
                  <div className="cj-audience-card__icon">{v.icon}</div>
                  <span className="cj-audience-card__index">{v.index}</span>
                </div>
                <div className="cj-audience-card__label">{c.label}</div>
                <h3>{c.h3}</h3>
                <p>{c.p}</p>
                <div className="cj-audience-card__foot">{c.foot}</div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AudienceCards;
